import { Error } from '../types/GenericFormTypes';

export const getFieldErrors = (
  errors: Error[],
  fieldId: string
): Error[] | undefined => {
  const fieldErrors = errors?.filter((e) => e.field === fieldId);
  return fieldErrors?.length > 0 ? fieldErrors : undefined;
};
